import React from "react";
import { Popover } from "mta-rkvr-styles";

const TitleWithInfo: React.FC<{
  titleTxt: string | JSX.Element;
  infTxt?: any;
  title?: boolean;
}> = ({ titleTxt, infTxt, title }) => {
  if (infTxt) {
    return (
      <>
        {titleTxt} {"  "}{" "}
        {infTxt && (
          <div
            style={{ display: "inline" }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <a
              href="javascript:void(0);"
              className= {title ? "icon-info ml-1 small-icon" : "icon-info ml-1 light-icon small-icon"}
              id={infTxt.target}
              aria-label={infTxt.target}
            />
          </div>
        )}{" "}
        {infTxt && <Popover {...infTxt} />}{" "}
      </>
    );
  } else {
    return <>{titleTxt}</>;
  }
};

export const getInfoForLabel = (label: string | JSX.Element, infotxt?: any): JSX.Element => {
  return <TitleWithInfo titleTxt={label} infTxt={infotxt} />;
};
export const getInfoForTitle = (label: string | JSX.Element, infotxt?: any): JSX.Element => {
  return <TitleWithInfo titleTxt={label} infTxt={infotxt} title={true}/>;
};

export default TitleWithInfo;
